import { Suspense } from "react";

/**
 * Mount a Create * drawer only while it is open. Suspense covers React.lazy.
 *
 * @param {object} props
 * @param {boolean} props.open
 * @param {*} props.Drawer Drawer component, including a lazy one.
 * @return {*}
 */
export const MountedQuickCreate = ({ open, Drawer, ...drawerProps }) => {
  if (!open || !Drawer) return null;
  return (
    <Suspense fallback={null}>
      <Drawer open={open} {...drawerProps} />
    </Suspense>
  );
};
